module.exports = __webpack_public_path__ + "ccdb309f578112dbc3de4e9158e3658b.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/wasistgoldencity.jpg
// module id = 783
// module chunks = 0